import React from 'react'
import { Edit } from 'react-admin'
import _ from 'lodash'

import EsquemaForm from '../Esquema/EsquemaForm'
import { schemaAsFieldArray } from '../../utils/schemas'


const InitialDataForm = (props) => {
    const { record } = props;
    const fields = schemaAsFieldArray(record.schema)
    const formData = {
        fields: _.map(fields, field => {
            field.name = field.title
            return field
        }),
        ...record
    }
    return <EsquemaForm redirect="list" initialValues={formData} edit={true} {...props}/>
}

export const FichaTecnicaEdit = props => (
    <Edit undoable={false} {...props}>
        <InitialDataForm />
    </Edit>
);
